import { z } from 'zod';
import { isValidRussianPhone } from '@/shared/lib/phone';
import { requiredText, textWithinLimit } from '@/shared/lib/validation';

/** Проверяет данные переноса профиля */
export const profilePhoneTransferSchema = z.object({
    phone: requiredText('Новый телефон')
        .refine(isValidRussianPhone, {
            message: 'Введите корректный номер телефона',
        }),
    comment: requiredText('Комментарий', 'Укажите причину и кто запросил смену телефона')
        .pipe(textWithinLimit(500, 'Комментарий не должен превышать 500 символов')),
});

/** Значения формы переноса профиля */
export type ProfilePhoneTransferFormValues = z.infer<typeof profilePhoneTransferSchema>;
